import { render } from "./allToTr.vue?vue&type=template&id=c9ba67ae&scoped=true"
import script from "./allToTr.vue?vue&type=script&lang=js"
export * from "./allToTr.vue?vue&type=script&lang=js"

import "./allToTr.vue?vue&type=style&index=0&id=c9ba67ae&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9ba67ae"]])

export default __exports__